<ng-container *ngIf="_caResult != null">
    <div class="cmps-cdk-p-1">
        <div>
            <cmps-ca-score-section
                [scorePercent]="_caResult?.scorePercent"
            ></cmps-ca-score-section>
        </div>
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-flex-start">
            <div
                class="cmps-cdk-font-size-10p cmps-cdk-color-unknown-122 cmps-cdk-font-italic"
            >
                {{ _caResult?.guideConfigName }}
            </div>
            <div class="cmps-cdk-flex-grow-1"></div>
            <div>
                <cmps-ca-analysis-dialog-toolbar
                    [evalRef]="this"
                    [background]="'light'"
                ></cmps-ca-analysis-dialog-toolbar>
            </div>
        </div>
    </div>
    <div>
        <cmps-accordion [multi]="true">
            <ng-container *ngFor="let g of _caResult?.groups">
                <cmps-accordion-item
                    class="cmps-cdk-border-width-0p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
                    [isOpen]="!_collapsed"
                >
                    <!-- TODO public accessor for cmps-accordion-item -> isOpen -->
                    <cmps-accordion-header
                        class="cmps-ca-evaluation--header cmps-cdk-bg-color-unknown-100 cmps-cdk-mb-0 cmps-cdk-p-0 hover:cmps-cdk-bg-color-unknown-107 cmps-cdk-border-l-width-4px cmps-cdk-border-l-solid cmps-cdk-border-l-color-blue-100"
                    >
                        <div class="cmps-cdk-flex-100">
                            <cmps-ca-evaluation-result-phase-header
                                [group]="g"
                            ></cmps-ca-evaluation-result-phase-header>
                        </div>
                    </cmps-accordion-header>
                    <cmps-accordion-content>
                        <div class="cmps-cdk-flex-100">
                            <cmps-ca-evaluation-result-phase-content
                                [group]="g"
                            ></cmps-ca-evaluation-result-phase-content>
                        </div>
                    </cmps-accordion-content>
                </cmps-accordion-item>
            </ng-container>
        </cmps-accordion>
    </div>
</ng-container>
